<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-prix-produit-cond-type-client-card">
    <div class="card-header">
      <h3 class="text-black fw-semibold">
        Définir un prix pour {{ produit?.nomProd || 'le produit' }}
      </h3>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="prixProduitCondTypeClientForm" @submit="addPrixProduitCondTypeClient"
        :validation-schema="prixProduitCondTypeClientSchema" :keep-values="valuess">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date de définition <span class="text-danger">*</span>
              </label>
              <Field name="dateDefinition" type="date" :value="getCurrentDate()"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Sélectionner la date de définition"
                readonly />
              <ErrorMessage name="dateDefinition" class="text-danger" />
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Groupe de Taxe<span class="text-danger">*</span>
              </label>
              <Field name="groupe" v-slot="{ setValue }">
                <Multiselect :options="groupeOptions" :searchable="true" track-by="value" label="label" v-model="groupe"
                  @update:modelValue="(val) => { setValue(val); onGroupeSelect(val); }"
                  placeholder="Sélectionner un groupe" />
              </Field>


              <ErrorMessage name="groupe" class="text-danger" />
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Mode de définition<span class="text-danger">*</span>
              </label>
              <Field name="mode" v-slot="{ setValue }">
                <Multiselect :options="modeOptions" :searchable="true" track-by="value" label="label" v-model="mode"
                  :disabled="estRedonly" @update:modelValue="(val) => { setValue(val); }"
                  placeholder="Sélectionner le mode de définition" />
              </Field>
              <ErrorMessage name="mode" class="text-danger" />
            </div>
          </div>
          <div class="col-md-12 m-10">
            <div class="row">
              <div class="border border-primary mb-10">
                <div class="row d-flex align-items-center justify-content-between fw-bold py-2 bg-primary">
                  <div class="col-md-7">
                    <h4 class="fs-4 text-white">Définir les prix</h4>
                  </div>
                  <div class="col-md-5">
                    <div class="d-flex float-end">
                      <button class="btn btn-sm btn-success" type="button" @click="addRowPrix()">
                        <i class="fa fa-plus-circle position-relative me-1 fs-12"></i>
                        Ajouter un prix
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                            <div class="p-3">
                              <div class="row mt-10">
                                <div class="col-md-5">
                                  <label class="d-block text-black fw-semibold">
                                    Produit Conditionnement <span class="text-danger">*</span>
                                  </label>
                                </div>
                                <div class="col-md-2">
                                  <label class="d-block text-black fw-semibold">
                                    Prix Min (XOF)
                                  </label>
                                </div>
                                <div class="col-md-2">
                                  <label class="d-block text-black fw-semibold">
                                    Prix de Vente (XOF) <span class="text-danger">*</span>
                                  </label>
                                </div>
                                <div class="col-md-2">
                                  <label class="d-block text-black fw-semibold">
                                    Prix Max (XOF)
                                  </label>
                                </div>
                                <div class="col-md-1">
                                  <label class="d-block text-black fw-semibold">Action</label>
                                </div>
                              </div>
                              <div class="row gy-0" v-for="(prix, prixIndex) in prixList" :key="prixIndex">
                                <div class="col-md-5">
                                  <div class="form-group mb-2">
                                    <Multiselect :options="produitConditionnementOptions" :searchable="true"
                                      track-by="label" label="label" v-model="prix.produitConditionnement"
                                      placeholder="Sélectionner le produit conditionnement"
                                      @select="selectProduitConditionnement(prix.produitConditionnement, prix)" />
                                    <div class="invalid-feedback" v-if="validatePrixRow(prix.produitConditionnement)">
                                      Le produit conditionnement est obligatoire.
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-2">
                                  <div class="form-group mb-2">
                                    <input type="number" v-model="prix.prixMin" step="0.01" min="0"
                                      class="form-control shadow-none fs-md-15 text-black" />
                                  </div>
                                </div>
                                <div class="col-md-2">
                                  <div class="form-group mb-2">
                                    <input type="number" v-model="prix.prix" step="0.01" min="0" :class="validatePrixRow(prix.prix) || prix.prix < prix.prixMin || prix.prix > prix.prixMax
                                      ? 'form-control shadow-none fs-md-15 text-black is-invalid'
                                      : 'form-control shadow-none fs-md-15 text-black'
                                      " placeholder="Entrez le prix en Francs CFA" />
                                    <div class="invalid-feedback" v-if="validatePrixRow(prix.prix)">
                                      Le prix est obligatoire.
                                    </div>
                                    <div class="invalid-feedback" v-if="prix.prix < prix.prixMin">
                                      Le prix doit être supérieur ou égal au prix minimum.
                                    </div>
                                    <div class="invalid-feedback" v-if="prix.prix > prix.prixMax">
                                      Le prix doit être inférieur ou égal au prix maximum.
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-2">
                                  <div class="form-group mb-2">
                                    <input type="number" v-model="prix.prixMax" step="0.01" min="0"
                                      class="form-control shadow-none fs-md-15 text-black" />
                                  </div>
                                </div>
                                <div class="col-md-1">
                                  <button class="btn btn-danger transition border-0 pb-2 ps-8 pe-8" type="button"
                                    @click="removeRowPrix(prixIndex)">
                                    <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 mt-5">
            <div class="d-flex align-items-center">
              <button class="btn btn-success me-3" type="submit" :disabled="isDisable"
                :class="{ 'cursor-not-allowed': isDisable }">
                Ajouter un prix produit conditionnement
              </button>
              <router-link to="/prixproduits/liste-prixproduits" class="btn btn-danger">
                <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative">Annuler</span>
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted, reactive } from 'vue';
import { Form, Field, ErrorMessage, useForm } from 'vee-validate';
import { error, success } from '@/utils/utils';
import { useRouter, useRoute } from 'vue-router';
import ApiService from '@/services/ApiService';
import * as Yup from 'yup';
import Multiselect from '@vueform/multiselect';
import { Produit } from '@/models/Produit';

export default defineComponent({
  name: 'AddPrixProduitCondTypeClient',
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const produitId = ref(route.params.produitId ? parseInt(route.params.produitId as string) : null);
    const produit = ref<Produit | null>(null);
    const produitConditionnementOptions = ref([]);
    const isDisable = ref(true);
    const valuess = ref();
    const groupeOptions = ref([]);
    const estRedonly = ref(true);
    const modeOptions = ref([
      { value: 'HT', label: 'HT' },
      { value: 'TTC', label: 'TTC' },
    ]);

    const mode = ref('');
    const groupe = ref('');
    const prixProduitCondTypeClientForm = ref(null);
    const { setFieldValue } = useForm();
    const prixList = reactive<any[]>([
      {
        produitConditionnement: '',
        prix: 0,
        prixMin: 0,
        prixMax: 0,
        prixHT: 0,
        prixTTC: 0,
      },
    ]);

    const prixProduitCondTypeClientSchema = Yup.object().shape({
      dateDefinition: Yup.date().required('La date de définition est obligatoire'),
      mode: Yup.string().required('Le mode de définition est obligatoire').oneOf(['HT', 'TTC'], 'Le mode doit être HT ou TTC'),
      groupe: Yup.string().required('Le groupe est obligatoire'),
    });

    const onGroupeSelect = (selectedGroupe: any) => {
      const groupeValue = selectedGroupe?.value || selectedGroupe;
      const code = selectedGroupe.split('|')[1];

      console.log('Groupe sélectionné:', groupeValue);

      if (code == 'B' || code == 'D') {
        estRedonly.value = false;
        mode.value = 'TTC';

        console.log('Mode défini sur TTC');
      } else {
        estRedonly.value = true;
        mode.value = 'HT';
      }
    };

    const calculePrix = (prix: number, produit: any) => {
      const taux = groupe.value.split('|')[2];
      const code = groupe.value.split('|')[1];
      console.log("valllll", taux);


      let prixHT = prix;
      let prixTTC = prix;
      if (code === 'D') {
        prixTTC = prix;
        prixTTC = prixHT * (1 + parseInt(taux) / 100);
      } else if (mode.value === 'HT') {
        prixHT = prix;
        prixTTC = prixHT * (1 + parseInt(taux) / 100);
      } else if (mode.value === 'TTC') {
        prixTTC = prix;
        prixHT = prixTTC / (1 + parseInt(taux) / 100);
      }

      produit.prixHT = prixHT,
        produit.prixTTC = prixTTC
      console.log("calcul", produit);
    };

    const addRowPrix = () => {
      prixList.push({
        produitConditionnement: '',
        prix: 0,
        prixMin: 0,
        prixMax: 0,
        prixHT: 0,
        prixTTC: 0,
      });
    };

    const removeRowPrix = (prixIndex: number) => {
      prixList.splice(prixIndex, 1);
    };

    const selectProduitConditionnement = (selectedProduit: string, prix: any) => {
      prix.produitConditionnement = selectedProduit;
    };

    const validatePrixRow = (value: any) => {
      return value === '' || value === 0 || value === null || value < 0;
    };

    watch(
      prixList,
      (newValue) => {
        isDisable.value = newValue.length === 0 || newValue.some(
          (prix) =>
            prix.produitConditionnement === '' ||
            prix.prix === 0 ||
            prix.prix < prix.prixMin ||
            prix.prix > prix.prixMax
        );
        newValue.forEach(element => {
          calculePrix(element.prix, element)
        });
      },
      { deep: true }
    );
    const getCurrentDate = () => {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, '0');
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const year = today.getFullYear();
      return `${year}-${month}-${day}`;
    };


    const fetchGroupeTaxe = async () => {
      try {
        const response = await ApiService.get("all/groupeTaxes");
        const groupeData = response.data.data.data;
        groupeOptions.value = groupeData.map((groupe) => ({
          value: `${groupe.id}|${groupe.code}|${groupe.taux}`,
          label: `${groupe.code} - ${groupe.libelle}`,
        }));
      } catch (error) {
        error('Erreur lors du chargement des groupes');
      }
    };


    const fetchDefiniPrix = (definiPrixId: string) => {
      return ApiService.get(`/produitconditionnement/${definiPrixId}`)
        .then(({ data }) => {
          console.log("valll", data);
          const definiPrix = data.data;
          console.log("valeurrrrr", definiPrix);

          const premierPrix = definiPrix
            .flatMap((pc: any) => pc.prixCategorieClients)
            .find((pcc: any) => pcc.groupeTaxe && pcc.mode);


          if (premierPrix) {
            const groupeKey = `${premierPrix.groupeTaxe.id}|${premierPrix.groupeTaxe.code}|${premierPrix.groupeTaxe.taux}`;

            const optionExiste = groupeOptions.value.find((opt: any) => opt.value === groupeKey);
            if (optionExiste) {
              groupe.value = groupeKey;
            } else {
              groupe.value = groupeKey;
            }

            mode.value = premierPrix.mode;

            prixProduitCondTypeClientForm.value?.setFieldValue('groupe', groupeKey);
            prixProduitCondTypeClientForm.value?.setFieldValue('mode', premierPrix.mode);

            const code = premierPrix.groupeTaxe.code;
            estRedonly.value = !(code === 'B' || code === 'D');
          }
          produitConditionnementOptions.value = definiPrix.map((produit: any) => ({
            value: produit.id,
            label: `${produit.produit.nomProd} [${produit.conditionnement.libelle}]`,
          }));

          // Pré-remplissage avec le prix actif (sans catégorie, sinon ancien prix "Standard")
          prixList.splice(0, prixList.length);
          definiPrix.forEach((produit: any) => {
            const prixActifs = Array.isArray(produit.prixCategorieClients) ? produit.prixCategorieClients : [];
            const prixActuel = prixActifs.find((p: any) => !p.categorieClient)
              || prixActifs.find((p: any) => p.categorieClient?.libelle === 'Standard')
              || {
                prix: produit.prixVente,
                prixMin: produit.prixMin,
                prixMax: produit.prixMax,
                prixHT: produit.prixVenteHt,
                prixTTC: produit.prixVenteTtc,
              };
            prixList.push({
              produitConditionnement: produit.id,
              prixMin: parseFloat(prixActuel.prixMin) || 0,
              prix: parseFloat(prixActuel.prix) || 0,
              prixMax: parseFloat(prixActuel.prixMax) || 0,
              prixHT: parseFloat(prixActuel.prixHT) || 0,
              prixTTC: parseFloat(prixActuel.prixTTC) || 0,
            });
          });
          if (prixList.length === 0) {
            addRowPrix();
          }

        }).catch(({ response }) => {
          error(response?.data?.message || 'Erreur lors de la récupération des produits conditionnement');
        });
    };


    const addPrixProduitCondTypeClient = async (values: any, { resetForm }: any) => {
      if (prixList.length === 0) {
        error('Veuillez ajouter au moins un prix.');
        return;
      }
      const produitConditionnementIds = new Set<string>();
      for (const prix of prixList) {
        if (
          !prix.produitConditionnement ||
          prix.prix <= 0 ||
          prix.prix < prix.prixMin ||
          prix.prix > prix.prixMax
        ) {
          error('Veuillez remplir tous les champs obligatoires.');
          return;
        }
        if (produitConditionnementIds.has(String(prix.produitConditionnement))) {
          error('Un produit conditionnement ne peut avoir qu\'un seul prix.');
          return;
        }
        produitConditionnementIds.add(String(prix.produitConditionnement));
      }

      const payloads = prixList.map((prix) => ({
        produitConditionnement: prix.produitConditionnement,
        prix: prix.prix,
        prixMin: prix.prixMin,
        prixMax: prix.prixMax,
        prixHT: prix.prixHT,
        prixTTC: prix.prixTTC,
        mode: values.mode?.value || values.mode,
      }));

      try {
        const response = await ApiService.post('/prixProduitCondTypeClients', { prixList: payloads, groupeTaxe: groupe.value, mode: mode.value });
        console.log("response", response)
        if (response.data && response.data.code === 201) {
          success('Prix produit conditionnement ajoutés avec succès');
          resetForm();
          router.push({ name: 'ListePrixProduitCondtionnementTypeClients' });
        } else {
          error('Certaines créations ont échoué');
          console.error('Erreurs dans la réponse:', response);
        }
      } catch (err) {
        error('Erreur lors de l\'ajout des prix produit conditionnement');
        console.error('Erreur API:', err);
      }
    };



    onMounted(async () => {
      const definiPrixId = route.query.definiPrixId as string;

      // await Promise.all([
      //   fetchDefiniPrix(definiPrixId),
      //   fetchGroupeTaxe(),
      // ]);
      await fetchGroupeTaxe();
      await fetchDefiniPrix(definiPrixId);

    });


    return {
      prixProduitCondTypeClientSchema,
      addPrixProduitCondTypeClient,
      produit,
      groupeOptions,
      modeOptions,
      produitConditionnementOptions,
      prixList,
      addRowPrix,
      removeRowPrix,
      validatePrixRow,
      selectProduitConditionnement,
      isDisable,
      getCurrentDate,
      valuess,
      calculePrix,
      estRedonly,
      mode,
      groupe,
      onGroupeSelect,
      prixProduitCondTypeClientForm,

    };
  },
});
</script>

<style scoped>
.cursor-not-allowed {
  cursor: not-allowed;
}

.accordion {
  max-width: 100%;
}

/* 
.btncolor {
  background-color: var(--theme-deafult);
  color: white;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 14px;
}


.btncolor2,
.btncolor2:disabled {
  background-color: var(--theme-deafult);
  border-color: var(--theme-deafult);
  color: white;
}

.btncolor2:disabled {
  opacity: 0.55;
  cursor: not-allowed;
} */
</style>